import { render, staticRenderFns } from "./RolesPermits.vue?vue&type=template&id=32682cd4"
import script from "./RolesPermits.vue?vue&type=script&lang=js"
export * from "./RolesPermits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports